import React, { useState } from 'react'
import './home_page_content.css'
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { NavLink, useHistory } from 'react-router-dom';
import Slider from "react-slick";
import { Select, Button, Input, Modal, Row, Col, Tabs } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import PlayarOneCard from '../playar_one_card/playarone_card'
import cardImgTop from '../../assets/img/harzard-scroll.png'
import xboxLogo from '../../assets/img/xbox.svg'
import cardFootericon from '../../assets/img/joint_user.svg'
import heartIcon from '../../assets/img/heart.svg'
import moneyIcon from '../../assets/img/naira.svg'
import vsIcon from '../../assets/img/vs.svg'
import tagIcon from '../../assets/img/tag.svg'
import gameImg from '../../assets/img/Intersection_new.png'
import playar1Logo from '../../assets/img/Playarone-logo-light.svg'
import heart from '../../assets/img/heart.svg'

const HomeContent = () => {

    let history = useHistory();

    const { TabPane } = Tabs;

    const [modalVisible, setModalVisible] = useState(false)

    const showModal = () => {
        if(window.outerWidth <= 580){
            history.push("/home-select")
        }else{
            showModalDesk()
        }
    }

    const showModalDesk = () => {
        setModalVisible(true)
    }

    const handleCancel = () => {
        setModalVisible(false)
    }

    const { Option } = Select;

    const settings = {
        infinite: true,
        autoplay: false,
        autoplaySpeed: 6000,
        speed: 500,
        slidesToShow: 5,
        slidesToScroll: 1,
        pauseOnHover: true,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                  slidesToShow: 3,
                  slidesToScroll: 1,
                  infinite: true
                }
              },
              {
                breakpoint: 575,
                settings: {
                  slidesToShow: 2,
                  slidesToScroll: 1
                }
              },
              {
                breakpoint: 480,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1
                }
              },
          ]
      };


    return(
        <div className="page_content">

            <Modal visible={modalVisible} onCancel={handleCancel}>
                <div className="modal_holder">
                    <Row>
                        <Col xs={{ span: 24 }}  sm={{ span: 14 }}  md={{ span: 14 }}  lg={{ span: 14 }} xl={{ span: 14 }} className="home_select_left">
                        <Tabs defaultActiveKey="1" >
                            <TabPane tab="overview" key="1">
                                <div className="game_title">
                                    <img src={playar1Logo} alt="" />
                                    <p>Sports / Racing</p>
                                </div>
                                <div className="game_header">
                                    <h1>Fifa 20:<br />
                                    Standard Edition</h1>
                                </div>
                                <div className="game_details">
                                    <ul>
                                        <li>₦24,000 Prize</li>
                                        <li>September 02</li>
                                        <li>
                                            <div className="level">
                                                18+
                                            </div>
                                        </li>
                                        <li>LV. 2</li>
                                    </ul>
                                </div>
                                <div className="game_description">
                                    <p>The overall winner takes home 90% of 
                                    total stakes. </p>
                                </div>
                                <div className="game_button">
                                    <NavLink exact to ="/home-select">
                                        <Button type="primary" className="create">Join Match</Button>
                                    </NavLink>
                                    <NavLink exact to ="/home-select">
                                        <Button type="primary" className="deposit">Added to my timeline</Button>
                                    </NavLink>
                                    <img src={heart} alt="" />
                                </div>
                            </TabPane>
                            <TabPane tab="rules & instruction" key="2">
                                <div className="game_title">
                                    <img src={playar1Logo} alt="" />
                                    <p>Rules & instruction</p>
                                </div>
                                <div className="game_header">
                                    <h1>Fifa 20:<br />
                                    Standard Edition</h1>
                                </div>
                                <div className="game_description">
                                    <p>The overall winner takes home 90% of 
                                    total stakes. </p>
                                </div>
                                <div className="game_button">
                                    <NavLink exact to ="/home-select">
                                        <Button type="primary" className="create">Join Match</Button>
                                    </NavLink>
                                    <NavLink exact to ="/home-select">
                                        <Button type="primary" className="deposit">Added to my timeline</Button>
                                    </NavLink>
                                    <img src={heart} alt="" />
                                </div>
                            </TabPane>
                            <TabPane tab="related matches" key="3">
                                <div className="game_title">
                                    <img src={playar1Logo} alt="" />
                                    <p>Related matches</p>
                                </div>
                                <div className="game_header">
                                    <h1>Fifa 20:<br />
                                    Standard Edition</h1>
                                </div>
                                <div className="game_description">
                                    <p>The overall winner takes home 90% of 
                                    total stakes. </p>
                                </div>
                                <div className="game_button">
                                    <NavLink exact to ="/home-select">
                                        <Button type="primary" className="create">Join Match</Button>
                                    </NavLink>
                                    <NavLink exact to ="/home-select">
                                        <Button type="primary" className="deposit">Added to my timeline</Button>
                                    </NavLink>
                                    <img src={heart} alt="" />
                                </div>
                            </TabPane>
                            <TabPane tab="game detail" key="4">
                                <div className="game_title">
                                    <img src={playar1Logo} alt="" />
                                    <p>Game detail</p>
                                </div>
                                <div className="game_header">
                                    <h1>Fifa 20:<br />
                                    Standard Edition</h1>
                                </div>
                                <div className="game_description">
                                    <p>The overall winner takes home 90% of 
                                    total stakes. </p>
                                </div>
                                <div className="game_button">
                                    <NavLink exact to ="/home-select">
                                        <Button type="primary" className="create">Join Match</Button>
                                    </NavLink>
                                    <NavLink exact to ="/home-select">
                                        <Button type="primary" className="deposit">Added to my timeline</Button>
                                    </NavLink>
                                    <img src={heart} alt="" />
                                </div>
                            </TabPane>
                        </Tabs>
                        </Col>
                        <Col xs={{ span: 24 }}  sm={{ span: 10 }}  md={{ span: 10 }}  lg={{ span: 10 }} xl={{ span: 10 }} className="home_select_right">
                            <img src={gameImg} alt=""/>
                        </Col>
                    </Row>
                </div>
            </Modal>

            <div className="recommended_games">
                <div className="top_bar">
                    <h2>Recommended Games</h2>
                    <div className="search_by">
                        <Input.Group compact>
                            <div className="search_preffix">
                                <SearchOutlined />
                            </div>
                            <Select defaultValue="Search Tag">
                                <Option value="Tag2-1">Tag2-1</Option>
                                <Option value="Tag2-2">Tag2-2</Option>
                            </Select>
                        </Input.Group>
                    </div>
                </div>
                <div className="regular_content">
                    <Slider {...settings}>

                        <div className="card_holder" onClick={showModal}>
                            <div className="card">
                                <div className="card_img_top">
                                    <img src={cardImgTop} alt=""/>
                                    <div className="card_img_overlay">
                                        <div className="top">
                                            <div className="level">
                                                <p>Lv. 2</p>
                                            </div>
                                            <div className="heart">
                                                <img src={heartIcon} alt=""/>
                                            </div>
                                        </div>
                                        <div className="bottom">
                                            <Button type="primary">Join Match</Button>
                                        </div>
                                    </div>
                                </div>
                                <div className="card_body">
                                    <h6>Sep 02 - Starting At 06:00 pm</h6>
                                    <div className="card_game_title">
                                        <img src={xboxLogo} alt="" style={{ width: '15px' }}/>
                                        <p>Fifa 20: Standard Edition</p>
                                    </div>
                                    <div className="pge_box">
                                        <div className="prize_pool">
                                            <label>Prize Pool</label>
                                            <p><img src={moneyIcon} alt="" style={{ width: '14px', marginRight: '2px' }} /> ₦5,000</p>
                                        </div>
                                        <div className="game_mode">
                                            <label>Game Mode</label>
                                            <p><img src={vsIcon} alt="" style={{ width: '14px', marginRight: '2px' }} /> 1 v 1</p>
                                        </div>
                                        <div className="entry_fee">
                                            <label>Entry Fee</label>
                                            <p><img src={tagIcon} alt="" style={{ width: '14px', marginRight: '2px' }} /> ₦2,500</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="card_footer">
                                    <img src={cardFootericon} alt="" style={{ width: '30px' }}/>
                                    <p>1 / 2 Signed</p>
                                </div>
                            </div>
                        </div>

                        <div className="card_holder" onClick={showModal}>
                            <div className="card">
                                <div className="card_img_top">
                                    <img src={cardImgTop} alt=""/>
                                    <div className="card_img_overlay">
                                        <div className="top">
                                            <div className="level">
                                                <p>Lv. 2</p>
                                            </div>
                                            <div className="heart">
                                                <img src={heartIcon} alt=""/>
                                            </div>
                                        </div>
                                        <div className="bottom">
                                            <Button type="primary">Join Match</Button>
                                        </div>
                                    </div>
                                </div>
                                <div className="card_body">
                                    <h6>Sep 02 - Starting At 06:00 pm</h6>
                                    <div className="card_game_title">
                                        <img src={xboxLogo} alt="" style={{ width: '15px' }}/>
                                        <p>Fifa 20: Standard Edition</p>
                                    </div>
                                    <div className="pge_box">
                                        <div className="prize_pool">
                                            <label>Prize Pool</label>
                                            <p><img src={moneyIcon} alt="" style={{ width: '14px', marginRight: '2px' }} /> ₦5,000</p>
                                        </div>
                                        <div className="game_mode">
                                            <label>Game Mode</label>
                                            <p><img src={vsIcon} alt="" style={{ width: '14px', marginRight: '2px' }} /> 1 v 1</p>
                                        </div>
                                        <div className="entry_fee">
                                            <label>Entry Fee</label>
                                            <p><img src={tagIcon} alt="" style={{ width: '14px', marginRight: '2px' }} /> ₦2,500</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="card_footer">
                                    <img src={cardFootericon} alt="" style={{ width: '30px' }}/>
                                    <p>1 / 2 Signed</p>
                                </div>
                            </div>
                        </div>
                    
                        <div className="card_holder" onClick={showModal}>
                            <div className="card">
                                <div className="card_img_top">
                                    <img src={cardImgTop} alt=""/>
                                    <div className="card_img_overlay">
                                        <div className="top">
                                            <div className="level">
                                                <p>Lv. 2</p>
                                            </div>
                                            <div className="heart">
                                                <img src={heartIcon} alt=""/>
                                            </div>
                                        </div>
                                        <div className="bottom">
                                            <Button type="primary">Join Match</Button>
                                        </div>
                                    </div>
                                </div>
                                <div className="card_body">
                                    <h6>Sep 02 - Starting At 06:00 pm</h6>
                                    <div className="card_game_title">
                                        <img src={xboxLogo} alt="" style={{ width: '15px' }}/>
                                        <p>Fifa 20: Standard Edition</p>
                                    </div>
                                    <div className="pge_box">
                                        <div className="prize_pool">
                                            <label>Prize Pool</label>
                                            <p><img src={moneyIcon} alt="" style={{ width: '14px', marginRight: '2px' }} /> ₦5,000</p>
                                        </div>
                                        <div className="game_mode">
                                            <label>Game Mode</label>
                                            <p><img src={vsIcon} alt="" style={{ width: '14px', marginRight: '2px' }} /> 1 v 1</p>
                                        </div>
                                        <div className="entry_fee">
                                            <label>Entry Fee</label>
                                            <p><img src={tagIcon} alt="" style={{ width: '14px', marginRight: '2px' }} /> ₦2,500</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="card_footer">
                                    <img src={cardFootericon} alt="" style={{ width: '30px' }}/>
                                    <p>1 / 2 Signed</p>
                                </div>
                            </div>
                        </div>

                        <div className="card_holder" onClick={showModal}>
                            <div className="card">
                                <div className="card_img_top">
                                    <img src={cardImgTop} alt=""/>
                                    <div className="card_img_overlay">
                                        <div className="top">
                                            <div className="level">
                                                <p>Lv. 2</p>
                                            </div>
                                            <div className="heart">
                                                <img src={heartIcon} alt=""/>
                                            </div>
                                        </div>
                                        <div className="bottom">
                                            <Button type="primary">Join Match</Button>
                                        </div>
                                    </div>
                                </div>
                                <div className="card_body">
                                    <h6>Sep 02 - Starting At 06:00 pm</h6>
                                    <div className="card_game_title">
                                        <img src={xboxLogo} alt="" style={{ width: '15px' }}/>
                                        <p>Fifa 20: Standard Edition</p>
                                    </div>
                                    <div className="pge_box">
                                        <div className="prize_pool">
                                            <label>Prize Pool</label>
                                            <p><img src={moneyIcon} alt="" style={{ width: '14px', marginRight: '2px' }} /> ₦5,000</p>
                                        </div>
                                        <div className="game_mode">
                                            <label>Game Mode</label>
                                            <p><img src={vsIcon} alt="" style={{ width: '14px', marginRight: '2px' }} /> 1 v 1</p>
                                        </div>
                                        <div className="entry_fee">
                                            <label>Entry Fee</label>
                                            <p><img src={tagIcon} alt="" style={{ width: '14px', marginRight: '2px' }} /> ₦2,500</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="card_footer">
                                    <img src={cardFootericon} alt="" style={{ width: '30px' }}/>
                                    <p>1 / 2 Signed</p>
                                </div>
                            </div>
                        </div>

                        <div className="card_holder" onClick={showModal}>
                            <div className="card">
                                <div className="card_img_top">
                                    <img src={cardImgTop} alt=""/>
                                    <div className="card_img_overlay">
                                        <div className="top">
                                            <div className="level">
                                                <p>Lv. 2</p>
                                            </div>
                                            <div className="heart">
                                                <img src={heartIcon} alt=""/>
                                            </div>
                                        </div>
                                        <div className="bottom">
                                            <Button type="primary">Join Match</Button>
                                        </div>
                                    </div>
                                </div>
                                <div className="card_body">
                                    <h6>Sep 02 - Starting At 06:00 pm</h6>
                                    <div className="card_game_title">
                                        <img src={xboxLogo} alt="" style={{ width: '15px' }}/>
                                        <p>Fifa 20: Standard Edition</p>
                                    </div>
                                    <div className="pge_box">
                                        <div className="prize_pool">
                                            <label>Prize Pool</label>
                                            <p><img src={moneyIcon} alt="" style={{ width: '14px', marginRight: '2px' }} /> ₦5,000</p>
                                        </div>
                                        <div className="game_mode">
                                            <label>Game Mode</label>
                                            <p><img src={vsIcon} alt="" style={{ width: '14px', marginRight: '2px' }} /> 1 v 1</p>
                                        </div>
                                        <div className="entry_fee">
                                            <label>Entry Fee</label>
                                            <p><img src={tagIcon} alt="" style={{ width: '14px', marginRight: '2px' }} /> ₦2,500</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="card_footer">
                                    <img src={cardFootericon} alt="" style={{ width: '30px' }}/>
                                    <p>1 / 2 Signed</p>
                                </div>
                            </div>
                        </div>

                        <div className="card_holder" onClick={showModal}>
                            <div className="card">
                                <div className="card_img_top">
                                    <img src={cardImgTop} alt=""/>
                                    <div className="card_img_overlay">
                                        <div className="top">
                                            <div className="level">
                                                <p>Lv. 2</p>
                                            </div>
                                            <div className="heart">
                                                <img src={heartIcon} alt=""/>
                                            </div>
                                        </div>
                                        <div className="bottom">
                                            <Button type="primary">Join Match</Button>
                                        </div>
                                    </div>
                                </div>
                                <div className="card_body">
                                    <h6>Sep 02 - Starting At 06:00 pm</h6>
                                    <div className="card_game_title">
                                        <img src={xboxLogo} alt="" style={{ width: '15px' }}/>
                                        <p>Fifa 20: Standard Edition</p>
                                    </div>
                                    <div className="pge_box">
                                        <div className="prize_pool">
                                            <label>Prize Pool</label>
                                            <p><img src={moneyIcon} alt="" style={{ width: '14px', marginRight: '2px' }} /> ₦5,000</p>
                                        </div>
                                        <div className="game_mode">
                                            <label>Game Mode</label>
                                            <p><img src={vsIcon} alt="" style={{ width: '14px', marginRight: '2px' }} /> 1 v 1</p>
                                        </div>
                                        <div className="entry_fee">
                                            <label>Entry Fee</label>
                                            <p><img src={tagIcon} alt="" style={{ width: '14px', marginRight: '2px' }} /> ₦2,500</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="card_footer">
                                    <img src={cardFootericon} alt="" style={{ width: '30px' }}/>
                                    <p>1 / 2 Signed</p>
                                </div>
                            </div>
                        </div>
                    
                    </Slider>
                </div>
            </div>
            
            <div className="all_games">
                <div className="top_bar">
                    <h2>All Games</h2>
                </div>

                <div className="sport_r_games">
                    <div className="mini_top_bar">
                        <h4 className="b4">Sports / Racing Games</h4>
                    </div>
                    <div className="regular_content">
                        <Slider {...settings}>

                            <div className="card_holder" onClick={showModal}>
                                <div className="card">
                                    <div className="card_img_top">
                                        <img src={cardImgTop} alt=""/>
                                        <div className="card_img_overlay">
                                            <div className="top">
                                                <div className="level">
                                                    <p>Lv. 2</p>
                                                </div>
                                                <div className="heart">
                                                    <img src={heartIcon} alt=""/>
                                                </div>
                                            </div>
                                            <div className="bottom">
                                                <Button type="primary">Join Match</Button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card_body">
                                        <h6>Sep 02 - Starting At 06:00 pm</h6>
                                        <div className="card_game_title">
                                            <img src={xboxLogo} alt="" style={{ width: '15px' }}/>
                                            <p>Fifa 20: Standard Edition</p>
                                        </div>
                                        <div className="pge_box">
                                            <div className="prize_pool">
                                                <label>Prize Pool</label>
                                                <p><img src={moneyIcon} alt="" style={{ width: '14px', marginRight: '2px' }} /> ₦5,000</p>
                                            </div>
                                            <div className="game_mode">
                                                <label>Game Mode</label>
                                                <p><img src={vsIcon} alt="" style={{ width: '14px', marginRight: '2px' }} /> 1 v 1</p>
                                            </div>
                                            <div className="entry_fee">
                                                <label>Entry Fee</label>
                                                <p><img src={tagIcon} alt="" style={{ width: '14px', marginRight: '2px' }} /> ₦2,500</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card_footer">
                                        <img src={cardFootericon} alt="" style={{ width: '30px' }}/>
                                        <p>1 / 2 Signed</p>
                                    </div>
                                </div>
                            </div>

                            <div className="card_holder" onClick={showModal}>
                                <div className="card">
                                    <div className="card_img_top">
                                        <img src={cardImgTop} alt=""/>
                                        <div className="card_img_overlay">
                                            <div className="top">
                                                <div className="level">
                                                    <p>Lv. 2</p>
                                                </div>
                                                <div className="heart">
                                                    <img src={heartIcon} alt=""/>
                                                </div>
                                            </div>
                                            <div className="bottom">
                                                <Button type="primary">Join Match</Button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card_body">
                                        <h6>Sep 02 - Starting At 06:00 pm</h6>
                                        <div className="card_game_title">
                                            <img src={xboxLogo} alt="" style={{ width: '15px' }}/>
                                            <p>Fifa 20: Standard Edition</p>
                                        </div>
                                        <div className="pge_box">
                                            <div className="prize_pool">
                                                <label>Prize Pool</label>
                                                <p><img src={moneyIcon} alt="" style={{ width: '14px', marginRight: '2px' }} /> ₦5,000</p>
                                            </div>
                                            <div className="game_mode">
                                                <label>Game Mode</label>
                                                <p><img src={vsIcon} alt="" style={{ width: '14px', marginRight: '2px' }} /> 1 v 1</p>
                                            </div>
                                            <div className="entry_fee">
                                                <label>Entry Fee</label>
                                                <p><img src={tagIcon} alt="" style={{ width: '14px', marginRight: '2px' }} /> ₦2,500</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card_footer">
                                        <img src={cardFootericon} alt="" style={{ width: '30px' }}/>
                                        <p>1 / 2 Signed</p>
                                    </div>
                                </div>
                            </div>
                        
                            <div className="card_holder" onClick={showModal}>
                                <div className="card">
                                    <div className="card_img_top">
                                        <img src={cardImgTop} alt=""/>
                                        <div className="card_img_overlay">
                                            <div className="top">
                                                <div className="level">
                                                    <p>Lv. 2</p>
                                                </div>
                                                <div className="heart">
                                                    <img src={heartIcon} alt=""/>
                                                </div>
                                            </div>
                                            <div className="bottom">
                                                <Button type="primary">Join Match</Button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card_body">
                                        <h6>Sep 02 - Starting At 06:00 pm</h6>
                                        <div className="card_game_title">
                                            <img src={xboxLogo} alt="" style={{ width: '15px' }}/>
                                            <p>Fifa 20: Standard Edition</p>
                                        </div>
                                        <div className="pge_box">
                                            <div className="prize_pool">
                                                <label>Prize Pool</label>
                                                <p><img src={moneyIcon} alt="" style={{ width: '14px', marginRight: '2px' }} /> ₦5,000</p>
                                            </div>
                                            <div className="game_mode">
                                                <label>Game Mode</label>
                                                <p><img src={vsIcon} alt="" style={{ width: '14px', marginRight: '2px' }} /> 1 v 1</p>
                                            </div>
                                            <div className="entry_fee">
                                                <label>Entry Fee</label>
                                                <p><img src={tagIcon} alt="" style={{ width: '14px', marginRight: '2px' }} /> ₦2,500</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card_footer">
                                        <img src={cardFootericon} alt="" style={{ width: '30px' }}/>
                                        <p>1 / 2 Signed</p>
                                    </div>
                                </div>
                            </div>

                            <div className="card_holder" onClick={showModal}>
                                <div className="card">
                                    <div className="card_img_top">
                                        <img src={cardImgTop} alt=""/>
                                        <div className="card_img_overlay">
                                            <div className="top">
                                                <div className="level">
                                                    <p>Lv. 2</p>
                                                </div>
                                                <div className="heart">
                                                    <img src={heartIcon} alt=""/>
                                                </div>
                                            </div>
                                            <div className="bottom">
                                                <Button type="primary">Join Match</Button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card_body">
                                        <h6>Sep 02 - Starting At 06:00 pm</h6>
                                        <div className="card_game_title">
                                            <img src={xboxLogo} alt="" style={{ width: '15px' }}/>
                                            <p>Fifa 20: Standard Edition</p>
                                        </div>
                                        <div className="pge_box">
                                            <div className="prize_pool">
                                                <label>Prize Pool</label>
                                                <p><img src={moneyIcon} alt="" style={{ width: '14px', marginRight: '2px' }} /> ₦5,000</p>
                                            </div>
                                            <div className="game_mode">
                                                <label>Game Mode</label>
                                                <p><img src={vsIcon} alt="" style={{ width: '14px', marginRight: '2px' }} /> 1 v 1</p>
                                            </div>
                                            <div className="entry_fee">
                                                <label>Entry Fee</label>
                                                <p><img src={tagIcon} alt="" style={{ width: '14px', marginRight: '2px' }} /> ₦2,500</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card_footer">
                                        <img src={cardFootericon} alt="" style={{ width: '30px' }}/>
                                        <p>1 / 2 Signed</p>
                                    </div>
                                </div>
                            </div>

                            <div className="card_holder" onClick={showModal}>
                                <div className="card">
                                    <div className="card_img_top">
                                        <img src={cardImgTop} alt=""/>
                                        <div className="card_img_overlay">
                                            <div className="top">
                                                <div className="level">
                                                    <p>Lv. 2</p>
                                                </div>
                                                <div className="heart">
                                                    <img src={heartIcon} alt=""/>
                                                </div>
                                            </div>
                                            <div className="bottom">
                                                <Button type="primary">Join Match</Button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card_body">
                                        <h6>Sep 02 - Starting At 06:00 pm</h6>
                                        <div className="card_game_title">
                                            <img src={xboxLogo} alt="" style={{ width: '15px' }}/>
                                            <p>Fifa 20: Standard Edition</p>
                                        </div>
                                        <div className="pge_box">
                                            <div className="prize_pool">
                                                <label>Prize Pool</label>
                                                <p><img src={moneyIcon} alt="" style={{ width: '14px', marginRight: '2px' }} /> ₦5,000</p>
                                            </div>
                                            <div className="game_mode">
                                                <label>Game Mode</label>
                                                <p><img src={vsIcon} alt="" style={{ width: '14px', marginRight: '2px' }} /> 1 v 1</p>
                                            </div>
                                            <div className="entry_fee">
                                                <label>Entry Fee</label>
                                                <p><img src={tagIcon} alt="" style={{ width: '14px', marginRight: '2px' }} /> ₦2,500</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card_footer">
                                        <img src={cardFootericon} alt="" style={{ width: '30px' }}/>
                                        <p>1 / 2 Signed</p>
                                    </div>
                                </div>
                            </div>

                            <div className="card_holder" onClick={showModal}>
                                <div className="card">
                                    <div className="card_img_top">
                                        <img src={cardImgTop} alt=""/>
                                        <div className="card_img_overlay">
                                            <div className="top">
                                                <div className="level">
                                                    <p>Lv. 2</p>
                                                </div>
                                                <div className="heart">
                                                    <img src={heartIcon} alt=""/>
                                                </div>
                                            </div>
                                            <div className="bottom">
                                                <Button type="primary">Join Match</Button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card_body">
                                        <h6>Sep 02 - Starting At 06:00 pm</h6>
                                        <div className="card_game_title">
                                            <img src={xboxLogo} alt="" style={{ width: '15px' }}/>
                                            <p>Fifa 20: Standard Edition</p>
                                        </div>
                                        <div className="pge_box">
                                            <div className="prize_pool">
                                                <label>Prize Pool</label>
                                                <p><img src={moneyIcon} alt="" style={{ width: '14px', marginRight: '2px' }} /> ₦5,000</p>
                                            </div>
                                            <div className="game_mode">
                                                <label>Game Mode</label>
                                                <p><img src={vsIcon} alt="" style={{ width: '14px', marginRight: '2px' }} /> 1 v 1</p>
                                            </div>
                                            <div className="entry_fee">
                                                <label>Entry Fee</label>
                                                <p><img src={tagIcon} alt="" style={{ width: '14px', marginRight: '2px' }} /> ₦2,500</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card_footer">
                                        <img src={cardFootericon} alt="" style={{ width: '30px' }}/>
                                        <p>1 / 2 Signed</p>
                                    </div>
                                </div>
                            </div>
                        
                        </Slider>
                    </div>
                </div>

                <div className="fighting_i_games">
                    <div className="mini_top_bar">
                        <h4 className="b4">Fighting / Indie Games</h4>
                    </div>
                    <div className="regular_content">
                        <Slider {...settings}>

                            <div className="card_holder" onClick={showModal}>
                                <div className="card">
                                    <div className="card_img_top">
                                        <img src={cardImgTop} alt=""/>
                                        <div className="card_img_overlay">
                                            <div className="top">
                                                <div className="level">
                                                    <p>Lv. 2</p>
                                                </div>
                                                <div className="heart">
                                                    <img src={heartIcon} alt=""/>
                                                </div>
                                            </div>
                                            <div className="bottom">
                                                <Button type="primary">Join Match</Button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card_body">
                                        <h6>Sep 02 - Starting At 06:00 pm</h6>
                                        <div className="card_game_title">
                                            <img src={xboxLogo} alt="" style={{ width: '15px' }}/>
                                            <p>Fifa 20: Standard Edition</p>
                                        </div>
                                        <div className="pge_box">
                                            <div className="prize_pool">
                                                <label>Prize Pool</label>
                                                <p><img src={moneyIcon} alt="" style={{ width: '14px', marginRight: '2px' }} /> ₦5,000</p>
                                            </div>
                                            <div className="game_mode">
                                                <label>Game Mode</label>
                                                <p><img src={vsIcon} alt="" style={{ width: '14px', marginRight: '2px' }} /> 1 v 1</p>
                                            </div>
                                            <div className="entry_fee">
                                                <label>Entry Fee</label>
                                                <p><img src={tagIcon} alt="" style={{ width: '14px', marginRight: '2px' }} /> ₦2,500</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card_footer">
                                        <img src={cardFootericon} alt="" style={{ width: '30px' }}/>
                                        <p>1 / 2 Signed</p>
                                    </div>
                                </div>
                            </div>

                            <div className="card_holder" onClick={showModal}>
                                <div className="card">
                                    <div className="card_img_top">
                                        <img src={cardImgTop} alt=""/>
                                        <div className="card_img_overlay">
                                            <div className="top">
                                                <div className="level">
                                                    <p>Lv. 2</p>
                                                </div>
                                                <div className="heart">
                                                    <img src={heartIcon} alt=""/>
                                                </div>
                                            </div>
                                            <div className="bottom">
                                                <Button type="primary">Join Match</Button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card_body">
                                        <h6>Sep 02 - Starting At 06:00 pm</h6>
                                        <div className="card_game_title">
                                            <img src={xboxLogo} alt="" style={{ width: '15px' }}/>
                                            <p>Fifa 20: Standard Edition</p>
                                        </div>
                                        <div className="pge_box">
                                            <div className="prize_pool">
                                                <label>Prize Pool</label>
                                                <p><img src={moneyIcon} alt="" style={{ width: '14px', marginRight: '2px' }} /> ₦5,000</p>
                                            </div>
                                            <div className="game_mode">
                                                <label>Game Mode</label>
                                                <p><img src={vsIcon} alt="" style={{ width: '14px', marginRight: '2px' }} /> 1 v 1</p>
                                            </div>
                                            <div className="entry_fee">
                                                <label>Entry Fee</label>
                                                <p><img src={tagIcon} alt="" style={{ width: '14px', marginRight: '2px' }} /> ₦2,500</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card_footer">
                                        <img src={cardFootericon} alt="" style={{ width: '30px' }}/>
                                        <p>1 / 2 Signed</p>
                                    </div>
                                </div>
                            </div>
                        
                            <div className="card_holder" onClick={showModal}>
                                <div className="card">
                                    <div className="card_img_top">
                                        <img src={cardImgTop} alt=""/>
                                        <div className="card_img_overlay">
                                            <div className="top">
                                                <div className="level">
                                                    <p>Lv. 2</p>
                                                </div>
                                                <div className="heart">
                                                    <img src={heartIcon} alt=""/>
                                                </div>
                                            </div>
                                            <div className="bottom">
                                                <Button type="primary">Join Match</Button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card_body">
                                        <h6>Sep 02 - Starting At 06:00 pm</h6>
                                        <div className="card_game_title">
                                            <img src={xboxLogo} alt="" style={{ width: '15px' }}/>
                                            <p>Fifa 20: Standard Edition</p>
                                        </div>
                                        <div className="pge_box">
                                            <div className="prize_pool">
                                                <label>Prize Pool</label>
                                                <p><img src={moneyIcon} alt="" style={{ width: '14px', marginRight: '2px' }} /> ₦5,000</p>
                                            </div>
                                            <div className="game_mode">
                                                <label>Game Mode</label>
                                                <p><img src={vsIcon} alt="" style={{ width: '14px', marginRight: '2px' }} /> 1 v 1</p>
                                            </div>
                                            <div className="entry_fee">
                                                <label>Entry Fee</label>
                                                <p><img src={tagIcon} alt="" style={{ width: '14px', marginRight: '2px' }} /> ₦2,500</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card_footer">
                                        <img src={cardFootericon} alt="" style={{ width: '30px' }}/>
                                        <p>1 / 2 Signed</p>
                                    </div>
                                </div>
                            </div>

                            <div className="card_holder" onClick={showModal}>
                                <div className="card">
                                    <div className="card_img_top">
                                        <img src={cardImgTop} alt=""/>
                                        <div className="card_img_overlay">
                                            <div className="top">
                                                <div className="level">
                                                    <p>Lv. 2</p>
                                                </div>
                                                <div className="heart">
                                                    <img src={heartIcon} alt=""/>
                                                </div>
                                            </div>
                                            <div className="bottom">
                                                <Button type="primary">Join Match</Button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card_body">
                                        <h6>Sep 02 - Starting At 06:00 pm</h6>
                                        <div className="card_game_title">
                                            <img src={xboxLogo} alt="" style={{ width: '15px' }}/>
                                            <p>Fifa 20: Standard Edition</p>
                                        </div>
                                        <div className="pge_box">
                                            <div className="prize_pool">
                                                <label>Prize Pool</label>
                                                <p><img src={moneyIcon} alt="" style={{ width: '14px', marginRight: '2px' }} /> ₦5,000</p>
                                            </div>
                                            <div className="game_mode">
                                                <label>Game Mode</label>
                                                <p><img src={vsIcon} alt="" style={{ width: '14px', marginRight: '2px' }} /> 1 v 1</p>
                                            </div>
                                            <div className="entry_fee">
                                                <label>Entry Fee</label>
                                                <p><img src={tagIcon} alt="" style={{ width: '14px', marginRight: '2px' }} /> ₦2,500</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card_footer">
                                        <img src={cardFootericon} alt="" style={{ width: '30px' }}/>
                                        <p>1 / 2 Signed</p>
                                    </div>
                                </div>
                            </div>

                            <div className="card_holder" onClick={showModal}>
                                <div className="card">
                                    <div className="card_img_top">
                                        <img src={cardImgTop} alt=""/>
                                        <div className="card_img_overlay">
                                            <div className="top">
                                                <div className="level">
                                                    <p>Lv. 2</p>
                                                </div>
                                                <div className="heart">
                                                    <img src={heartIcon} alt=""/>
                                                </div>
                                            </div>
                                            <div className="bottom">
                                                <Button type="primary">Join Match</Button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card_body">
                                        <h6>Sep 02 - Starting At 06:00 pm</h6>
                                        <div className="card_game_title">
                                            <img src={xboxLogo} alt="" style={{ width: '15px' }}/>
                                            <p>Fifa 20: Standard Edition</p>
                                        </div>
                                        <div className="pge_box">
                                            <div className="prize_pool">
                                                <label>Prize Pool</label>
                                                <p><img src={moneyIcon} alt="" style={{ width: '14px', marginRight: '2px' }} /> ₦5,000</p>
                                            </div>
                                            <div className="game_mode">
                                                <label>Game Mode</label>
                                                <p><img src={vsIcon} alt="" style={{ width: '14px', marginRight: '2px' }} /> 1 v 1</p>
                                            </div>
                                            <div className="entry_fee">
                                                <label>Entry Fee</label>
                                                <p><img src={tagIcon} alt="" style={{ width: '14px', marginRight: '2px' }} /> ₦2,500</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card_footer">
                                        <img src={cardFootericon} alt="" style={{ width: '30px' }}/>
                                        <p>1 / 2 Signed</p>
                                    </div>
                                </div>
                            </div>

                            <div className="card_holder" onClick={showModal}>
                                <div className="card">
                                    <div className="card_img_top">
                                        <img src={cardImgTop} alt=""/>
                                        <div className="card_img_overlay">
                                            <div className="top">
                                                <div className="level">
                                                    <p>Lv. 2</p>
                                                </div>
                                                <div className="heart">
                                                    <img src={heartIcon} alt=""/>
                                                </div>
                                            </div>
                                            <div className="bottom">
                                                <Button type="primary">Join Match</Button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card_body">
                                        <h6>Sep 02 - Starting At 06:00 pm</h6>
                                        <div className="card_game_title">
                                            <img src={xboxLogo} alt="" style={{ width: '15px' }}/>
                                            <p>Fifa 20: Standard Edition</p>
                                        </div>
                                        <div className="pge_box">
                                            <div className="prize_pool">
                                                <label>Prize Pool</label>
                                                <p><img src={moneyIcon} alt="" style={{ width: '14px', marginRight: '2px' }} /> ₦5,000</p>
                                            </div>
                                            <div className="game_mode">
                                                <label>Game Mode</label>
                                                <p><img src={vsIcon} alt="" style={{ width: '14px', marginRight: '2px' }} /> 1 v 1</p>
                                            </div>
                                            <div className="entry_fee">
                                                <label>Entry Fee</label>
                                                <p><img src={tagIcon} alt="" style={{ width: '14px', marginRight: '2px' }} /> ₦2,500</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card_footer">
                                        <img src={cardFootericon} alt="" style={{ width: '30px' }}/>
                                        <p>1 / 2 Signed</p>
                                    </div>
                                </div>
                            </div>
                        
                        </Slider>
                    </div>
                </div>

                <div className="mobile_games">
                    <div className="mini_top_bar">
                        <h4 className="b4">Mobile Games</h4>
                    </div>
                    <div className="regular_content">
                        <Slider {...settings}>

                            <div className="card_holder" onClick={showModal}>
                                <div className="card">
                                    <div className="card_img_top">
                                        <img src={cardImgTop} alt=""/>
                                        <div className="card_img_overlay">
                                            <div className="top">
                                                <div className="level">
                                                    <p>Lv. 2</p>
                                                </div>
                                                <div className="heart">
                                                    <img src={heartIcon} alt=""/>
                                                </div>
                                            </div>
                                            <div className="bottom">
                                                <Button type="primary">Join Match</Button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card_body">
                                        <h6>Sep 02 - Starting At 06:00 pm</h6>
                                        <div className="card_game_title">
                                            <img src={xboxLogo} alt="" style={{ width: '15px' }}/>
                                            <p>Fifa 20: Standard Edition</p>
                                        </div>
                                        <div className="pge_box">
                                            <div className="prize_pool">
                                                <label>Prize Pool</label>
                                                <p><img src={moneyIcon} alt="" style={{ width: '14px', marginRight: '2px' }} /> ₦5,000</p>
                                            </div>
                                            <div className="game_mode">
                                                <label>Game Mode</label>
                                                <p><img src={vsIcon} alt="" style={{ width: '14px', marginRight: '2px' }} /> 1 v 1</p>
                                            </div>
                                            <div className="entry_fee">
                                                <label>Entry Fee</label>
                                                <p><img src={tagIcon} alt="" style={{ width: '14px', marginRight: '2px' }} /> ₦2,500</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card_footer">
                                        <img src={cardFootericon} alt="" style={{ width: '30px' }}/>
                                        <p>1 / 2 Signed</p>
                                    </div>
                                </div>
                            </div>

                            <div className="card_holder" onClick={showModal}>
                                <div className="card">
                                    <div className="card_img_top">
                                        <img src={cardImgTop} alt=""/>
                                        <div className="card_img_overlay">
                                            <div className="top">
                                                <div className="level">
                                                    <p>Lv. 2</p>
                                                </div>
                                                <div className="heart">
                                                    <img src={heartIcon} alt=""/>
                                                </div>
                                            </div>
                                            <div className="bottom">
                                                <Button type="primary">Join Match</Button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card_body">
                                        <h6>Sep 02 - Starting At 06:00 pm</h6>
                                        <div className="card_game_title">
                                            <img src={xboxLogo} alt="" style={{ width: '15px' }}/>
                                            <p>Fifa 20: Standard Edition</p>
                                        </div>
                                        <div className="pge_box">
                                            <div className="prize_pool">
                                                <label>Prize Pool</label>
                                                <p><img src={moneyIcon} alt="" style={{ width: '14px', marginRight: '2px' }} /> ₦5,000</p>
                                            </div>
                                            <div className="game_mode">
                                                <label>Game Mode</label>
                                                <p><img src={vsIcon} alt="" style={{ width: '14px', marginRight: '2px' }} /> 1 v 1</p>
                                            </div>
                                            <div className="entry_fee">
                                                <label>Entry Fee</label>
                                                <p><img src={tagIcon} alt="" style={{ width: '14px', marginRight: '2px' }} /> ₦2,500</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card_footer">
                                        <img src={cardFootericon} alt="" style={{ width: '30px' }}/>
                                        <p>1 / 2 Signed</p>
                                    </div>
                                </div>
                            </div>
                        
                            <div className="card_holder" onClick={showModal}>
                                <div className="card">
                                    <div className="card_img_top">
                                        <img src={cardImgTop} alt=""/>
                                        <div className="card_img_overlay">
                                            <div className="top">
                                                <div className="level">
                                                    <p>Lv. 2</p>
                                                </div>
                                                <div className="heart">
                                                    <img src={heartIcon} alt=""/>
                                                </div>
                                            </div>
                                            <div className="bottom">
                                                <Button type="primary">Join Match</Button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card_body">
                                        <h6>Sep 02 - Starting At 06:00 pm</h6>
                                        <div className="card_game_title">
                                            <img src={xboxLogo} alt="" style={{ width: '15px' }}/>
                                            <p>Fifa 20: Standard Edition</p>
                                        </div>
                                        <div className="pge_box">
                                            <div className="prize_pool">
                                                <label>Prize Pool</label>
                                                <p><img src={moneyIcon} alt="" style={{ width: '14px', marginRight: '2px' }} /> ₦5,000</p>
                                            </div>
                                            <div className="game_mode">
                                                <label>Game Mode</label>
                                                <p><img src={vsIcon} alt="" style={{ width: '14px', marginRight: '2px' }} /> 1 v 1</p>
                                            </div>
                                            <div className="entry_fee">
                                                <label>Entry Fee</label>
                                                <p><img src={tagIcon} alt="" style={{ width: '14px', marginRight: '2px' }} /> ₦2,500</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card_footer">
                                        <img src={cardFootericon} alt="" style={{ width: '30px' }}/>
                                        <p>1 / 2 Signed</p>
                                    </div>
                                </div>
                            </div>

                            <div className="card_holder" onClick={showModal}>
                                <div className="card">
                                    <div className="card_img_top">
                                        <img src={cardImgTop} alt=""/>
                                        <div className="card_img_overlay">
                                            <div className="top">
                                                <div className="level">
                                                    <p>Lv. 2</p>
                                                </div>
                                                <div className="heart">
                                                    <img src={heartIcon} alt=""/>
                                                </div>
                                            </div>
                                            <div className="bottom">
                                                <Button type="primary">Join Match</Button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card_body">
                                        <h6>Sep 02 - Starting At 06:00 pm</h6>
                                        <div className="card_game_title">
                                            <img src={xboxLogo} alt="" style={{ width: '15px' }}/>
                                            <p>Fifa 20: Standard Edition</p>
                                        </div>
                                        <div className="pge_box">
                                            <div className="prize_pool">
                                                <label>Prize Pool</label>
                                                <p><img src={moneyIcon} alt="" style={{ width: '14px', marginRight: '2px' }} /> ₦5,000</p>
                                            </div>
                                            <div className="game_mode">
                                                <label>Game Mode</label>
                                                <p><img src={vsIcon} alt="" style={{ width: '14px', marginRight: '2px' }} /> 1 v 1</p>
                                            </div>
                                            <div className="entry_fee">
                                                <label>Entry Fee</label>
                                                <p><img src={tagIcon} alt="" style={{ width: '14px', marginRight: '2px' }} /> ₦2,500</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card_footer">
                                        <img src={cardFootericon} alt="" style={{ width: '30px' }}/>
                                        <p>1 / 2 Signed</p>
                                    </div>
                                </div>
                            </div>

                            <div className="card_holder" onClick={showModal}>
                                <div className="card">
                                    <div className="card_img_top">
                                        <img src={cardImgTop} alt=""/>
                                        <div className="card_img_overlay">
                                            <div className="top">
                                                <div className="level">
                                                    <p>Lv. 2</p>
                                                </div>
                                                <div className="heart">
                                                    <img src={heartIcon} alt=""/>
                                                </div>
                                            </div>
                                            <div className="bottom">
                                                <Button type="primary">Join Match</Button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card_body">
                                        <h6>Sep 02 - Starting At 06:00 pm</h6>
                                        <div className="card_game_title">
                                            <img src={xboxLogo} alt="" style={{ width: '15px' }}/>
                                            <p>Fifa 20: Standard Edition</p>
                                        </div>
                                        <div className="pge_box">
                                            <div className="prize_pool">
                                                <label>Prize Pool</label>
                                                <p><img src={moneyIcon} alt="" style={{ width: '14px', marginRight: '2px' }} /> ₦5,000</p>
                                            </div>
                                            <div className="game_mode">
                                                <label>Game Mode</label>
                                                <p><img src={vsIcon} alt="" style={{ width: '14px', marginRight: '2px' }} /> 1 v 1</p>
                                            </div>
                                            <div className="entry_fee">
                                                <label>Entry Fee</label>
                                                <p><img src={tagIcon} alt="" style={{ width: '14px', marginRight: '2px' }} /> ₦2,500</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card_footer">
                                        <img src={cardFootericon} alt="" style={{ width: '30px' }}/>
                                        <p>1 / 2 Signed</p>
                                    </div>
                                </div>
                            </div>

                            <div className="card_holder" onClick={showModal}>
                                <div className="card">
                                    <div className="card_img_top">
                                        <img src={cardImgTop} alt=""/>
                                        <div className="card_img_overlay">
                                            <div className="top">
                                                <div className="level">
                                                    <p>Lv. 2</p>
                                                </div>
                                                <div className="heart">
                                                    <img src={heartIcon} alt=""/>
                                                </div>
                                            </div>
                                            <div className="bottom">
                                                <Button type="primary">Join Match</Button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card_body">
                                        <h6>Sep 02 - Starting At 06:00 pm</h6>
                                        <div className="card_game_title">
                                            <img src={xboxLogo} alt="" style={{ width: '15px' }}/>
                                            <p>Fifa 20: Standard Edition</p>
                                        </div>
                                        <div className="pge_box">
                                            <div className="prize_pool">
                                                <label>Prize Pool</label>
                                                <p><img src={moneyIcon} alt="" style={{ width: '14px', marginRight: '2px' }} /> ₦5,000</p>
                                            </div>
                                            <div className="game_mode">
                                                <label>Game Mode</label>
                                                <p><img src={vsIcon} alt="" style={{ width: '14px', marginRight: '2px' }} /> 1 v 1</p>
                                            </div>
                                            <div className="entry_fee">
                                                <label>Entry Fee</label>
                                                <p><img src={tagIcon} alt="" style={{ width: '14px', marginRight: '2px' }} /> ₦2,500</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card_footer">
                                        <img src={cardFootericon} alt="" style={{ width: '30px' }}/>
                                        <p>1 / 2 Signed</p>
                                    </div>
                                </div>
                            </div>
                        
                        </Slider>
                    </div>
                </div>
                <hr />

                <PlayarOneCard />

                <hr />

                <div className="featured_tournament">
                    <div className="mini_top_bar">
                        <h4>Featured Tournaments</h4>
                    </div>
                    <div className="regular_content">
                        <Slider {...settings}>

                            <div className="card_holder" onClick={showModal}>
                                <div className="card">
                                    <div className="card_img_top">
                                        <img src={cardImgTop} alt=""/>
                                        <div className="card_img_overlay">
                                            <div className="top">
                                                <div className="level">
                                                    <p>Lv. 2</p>
                                                </div>
                                                <div className="heart">
                                                    <img src={heartIcon} alt=""/>
                                                </div>
                                            </div>
                                            <div className="bottom">
                                                <Button type="primary">Join Match</Button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card_body">
                                        <h6>Sep 02 - Starting At 06:00 pm</h6>
                                        <div className="card_game_title">
                                            <img src={xboxLogo} alt="" style={{ width: '15px' }}/>
                                            <p>Fifa 20: Standard Edition</p>
                                        </div>
                                        <div className="pge_box">
                                            <div className="prize_pool">
                                                <label>Prize Pool</label>
                                                <p><img src={moneyIcon} alt="" style={{ width: '14px', marginRight: '2px' }} /> ₦5,000</p>
                                            </div>
                                            <div className="game_mode">
                                                <label>Game Mode</label>
                                                <p><img src={vsIcon} alt="" style={{ width: '14px', marginRight: '2px' }} /> 1 v 1</p>
                                            </div>
                                            <div className="entry_fee">
                                                <label>Entry Fee</label>
                                                <p><img src={tagIcon} alt="" style={{ width: '14px', marginRight: '2px' }} /> ₦2,500</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card_footer">
                                        <img src={cardFootericon} alt="" style={{ width: '30px' }}/>
                                        <p>1 / 2 Signed</p>
                                    </div>
                                </div>
                            </div>

                            <div className="card_holder" onClick={showModal}>
                                <div className="card">
                                    <div className="card_img_top">
                                        <img src={cardImgTop} alt=""/>
                                        <div className="card_img_overlay">
                                            <div className="top">
                                                <div className="level">
                                                    <p>Lv. 2</p>
                                                </div>
                                                <div className="heart">
                                                    <img src={heartIcon} alt=""/>
                                                </div>
                                            </div>
                                            <div className="bottom">
                                                <Button type="primary">Join Match</Button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card_body">
                                        <h6>Sep 02 - Starting At 06:00 pm</h6>
                                        <div className="card_game_title">
                                            <img src={xboxLogo} alt="" style={{ width: '15px' }}/>
                                            <p>Fifa 20: Standard Edition</p>
                                        </div>
                                        <div className="pge_box">
                                            <div className="prize_pool">
                                                <label>Prize Pool</label>
                                                <p><img src={moneyIcon} alt="" style={{ width: '14px', marginRight: '2px' }} /> ₦5,000</p>
                                            </div>
                                            <div className="game_mode">
                                                <label>Game Mode</label>
                                                <p><img src={vsIcon} alt="" style={{ width: '14px', marginRight: '2px' }} /> 1 v 1</p>
                                            </div>
                                            <div className="entry_fee">
                                                <label>Entry Fee</label>
                                                <p><img src={tagIcon} alt="" style={{ width: '14px', marginRight: '2px' }} /> ₦2,500</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card_footer">
                                        <img src={cardFootericon} alt="" style={{ width: '30px' }}/>
                                        <p>1 / 2 Signed</p>
                                    </div>
                                </div>
                            </div>
                        
                            <div className="card_holder" onClick={showModal}>
                                <div className="card">
                                    <div className="card_img_top">
                                        <img src={cardImgTop} alt=""/>
                                        <div className="card_img_overlay">
                                            <div className="top">
                                                <div className="level">
                                                    <p>Lv. 2</p>
                                                </div>
                                                <div className="heart">
                                                    <img src={heartIcon} alt=""/>
                                                </div>
                                            </div>
                                            <div className="bottom">
                                                <Button type="primary">Join Match</Button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card_body">
                                        <h6>Sep 02 - Starting At 06:00 pm</h6>
                                        <div className="card_game_title">
                                            <img src={xboxLogo} alt="" style={{ width: '15px' }}/>
                                            <p>Fifa 20: Standard Edition</p>
                                        </div>
                                        <div className="pge_box">
                                            <div className="prize_pool">
                                                <label>Prize Pool</label>
                                                <p><img src={moneyIcon} alt="" style={{ width: '14px', marginRight: '2px' }} /> ₦5,000</p>
                                            </div>
                                            <div className="game_mode">
                                                <label>Game Mode</label>
                                                <p><img src={vsIcon} alt="" style={{ width: '14px', marginRight: '2px' }} /> 1 v 1</p>
                                            </div>
                                            <div className="entry_fee">
                                                <label>Entry Fee</label>
                                                <p><img src={tagIcon} alt="" style={{ width: '14px', marginRight: '2px' }} /> ₦2,500</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card_footer">
                                        <img src={cardFootericon} alt="" style={{ width: '30px' }}/>
                                        <p>1 / 2 Signed</p>
                                    </div>
                                </div>
                            </div>

                            <div className="card_holder" onClick={showModal}>
                                <div className="card">
                                    <div className="card_img_top">
                                        <img src={cardImgTop} alt=""/>
                                        <div className="card_img_overlay">
                                            <div className="top">
                                                <div className="level">
                                                    <p>Lv. 2</p>
                                                </div>
                                                <div className="heart">
                                                    <img src={heartIcon} alt=""/>
                                                </div>
                                            </div>
                                            <div className="bottom">
                                                <Button type="primary">Join Match</Button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card_body">
                                        <h6>Sep 02 - Starting At 06:00 pm</h6>
                                        <div className="card_game_title">
                                            <img src={xboxLogo} alt="" style={{ width: '15px' }}/>
                                            <p>Fifa 20: Standard Edition</p>
                                        </div>
                                        <div className="pge_box">
                                            <div className="prize_pool">
                                                <label>Prize Pool</label>
                                                <p><img src={moneyIcon} alt="" style={{ width: '14px', marginRight: '2px' }} /> ₦5,000</p>
                                            </div>
                                            <div className="game_mode">
                                                <label>Game Mode</label>
                                                <p><img src={vsIcon} alt="" style={{ width: '14px', marginRight: '2px' }} /> 1 v 1</p>
                                            </div>
                                            <div className="entry_fee">
                                                <label>Entry Fee</label>
                                                <p><img src={tagIcon} alt="" style={{ width: '14px', marginRight: '2px' }} /> ₦2,500</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card_footer">
                                        <img src={cardFootericon} alt="" style={{ width: '30px' }}/>
                                        <p>1 / 2 Signed</p>
                                    </div>
                                </div>
                            </div>

                            <div className="card_holder" onClick={showModal}>
                                <div className="card">
                                    <div className="card_img_top">
                                        <img src={cardImgTop} alt=""/>
                                        <div className="card_img_overlay">
                                            <div className="top">
                                                <div className="level">
                                                    <p>Lv. 2</p>
                                                </div>
                                                <div className="heart">
                                                    <img src={heartIcon} alt=""/>
                                                </div>
                                            </div>
                                            <div className="bottom">
                                                <Button type="primary">Join Match</Button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card_body">
                                        <h6>Sep 02 - Starting At 06:00 pm</h6>
                                        <div className="card_game_title">
                                            <img src={xboxLogo} alt="" style={{ width: '15px' }}/>
                                            <p>Fifa 20: Standard Edition</p>
                                        </div>
                                        <div className="pge_box">
                                            <div className="prize_pool">
                                                <label>Prize Pool</label>
                                                <p><img src={moneyIcon} alt="" style={{ width: '14px', marginRight: '2px' }} /> ₦5,000</p>
                                            </div>
                                            <div className="game_mode">
                                                <label>Game Mode</label>
                                                <p><img src={vsIcon} alt="" style={{ width: '14px', marginRight: '2px' }} /> 1 v 1</p>
                                            </div>
                                            <div className="entry_fee">
                                                <label>Entry Fee</label>
                                                <p><img src={tagIcon} alt="" style={{ width: '14px', marginRight: '2px' }} /> ₦2,500</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card_footer">
                                        <img src={cardFootericon} alt="" style={{ width: '30px' }}/>
                                        <p>1 / 2 Signed</p>
                                    </div>
                                </div>
                            </div>

                            <div className="card_holder" onClick={showModal}>
                                <div className="card">
                                    <div className="card_img_top">
                                        <img src={cardImgTop} alt=""/>
                                        <div className="card_img_overlay">
                                            <div className="top">
                                                <div className="level">
                                                    <p>Lv. 2</p>
                                                </div>
                                                <div className="heart">
                                                    <img src={heartIcon} alt=""/>
                                                </div>
                                            </div>
                                            <div className="bottom">
                                                <Button type="primary">Join Match</Button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card_body">
                                        <h6>Sep 02 - Starting At 06:00 pm</h6>
                                        <div className="card_game_title">
                                            <img src={xboxLogo} alt="" style={{ width: '15px' }}/>
                                            <p>Fifa 20: Standard Edition</p>
                                        </div>
                                        <div className="pge_box">
                                            <div className="prize_pool">
                                                <label>Prize Pool</label>
                                                <p><img src={moneyIcon} alt="" style={{ width: '14px', marginRight: '2px' }} /> ₦5,000</p>
                                            </div>
                                            <div className="game_mode">
                                                <label>Game Mode</label>
                                                <p><img src={vsIcon} alt="" style={{ width: '14px', marginRight: '2px' }} /> 1 v 1</p>
                                            </div>
                                            <div className="entry_fee">
                                                <label>Entry Fee</label>
                                                <p><img src={tagIcon} alt="" style={{ width: '14px', marginRight: '2px' }} /> ₦2,500</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card_footer">
                                        <img src={cardFootericon} alt="" style={{ width: '30px' }}/>
                                        <p>1 / 2 Signed</p>
                                    </div>
                                </div>
                            </div>
                        
                        </Slider>
                    </div>
                </div>
                
                <hr />

                <div className="upcoming_tournament">
                    <div className="mini_top_bar">
                        <h4>Upcoming Tournaments <br />
                        (PlayarOne Sponsored)</h4>
                    </div>
                    <div className="regular_content">
                        <Slider {...settings}>

                            <div className="card_holder" onClick={showModal}>
                                <div className="card">
                                    <div className="card_img_top">
                                        <img src={cardImgTop} alt=""/>
                                        <div className="card_img_overlay">
                                            <div className="top">
                                                <div className="level">
                                                    <p>Lv. 2</p>
                                                </div>
                                                <div className="heart">
                                                    <img src={heartIcon} alt=""/>
                                                </div>
                                            </div>
                                            <div className="bottom">
                                                <Button type="primary">Join Match</Button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card_body">
                                        <h6>Sep 02 - Starting At 06:00 pm</h6>
                                        <div className="card_game_title">
                                            <img src={xboxLogo} alt="" style={{ width: '15px' }}/>
                                            <p>Fifa 20: Standard Edition</p>
                                        </div>
                                        <div className="pge_box">
                                            <div className="prize_pool">
                                                <label>Prize Pool</label>
                                                <p><img src={moneyIcon} alt="" style={{ width: '14px', marginRight: '2px' }} /> ₦5,000</p>
                                            </div>
                                            <div className="game_mode">
                                                <label>Game Mode</label>
                                                <p><img src={vsIcon} alt="" style={{ width: '14px', marginRight: '2px' }} /> 1 v 1</p>
                                            </div>
                                            <div className="entry_fee">
                                                <label>Entry Fee</label>
                                                <p><img src={tagIcon} alt="" style={{ width: '14px', marginRight: '2px' }} /> ₦2,500</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card_footer">
                                        <img src={cardFootericon} alt="" style={{ width: '30px' }}/>
                                        <p>1 / 2 Signed</p>
                                    </div>
                                </div>
                            </div>

                            <div className="card_holder" onClick={showModal}>
                                <div className="card">
                                    <div className="card_img_top">
                                        <img src={cardImgTop} alt=""/>
                                        <div className="card_img_overlay">
                                            <div className="top">
                                                <div className="level">
                                                    <p>Lv. 2</p>
                                                </div>
                                                <div className="heart">
                                                    <img src={heartIcon} alt=""/>
                                                </div>
                                            </div>
                                            <div className="bottom">
                                                <Button type="primary">Join Match</Button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card_body">
                                        <h6>Sep 02 - Starting At 06:00 pm</h6>
                                        <div className="card_game_title">
                                            <img src={xboxLogo} alt="" style={{ width: '15px' }}/>
                                            <p>Fifa 20: Standard Edition</p>
                                        </div>
                                        <div className="pge_box">
                                            <div className="prize_pool">
                                                <label>Prize Pool</label>
                                                <p><img src={moneyIcon} alt="" style={{ width: '14px', marginRight: '2px' }} /> ₦5,000</p>
                                            </div>
                                            <div className="game_mode">
                                                <label>Game Mode</label>
                                                <p><img src={vsIcon} alt="" style={{ width: '14px', marginRight: '2px' }} /> 1 v 1</p>
                                            </div>
                                            <div className="entry_fee">
                                                <label>Entry Fee</label>
                                                <p><img src={tagIcon} alt="" style={{ width: '14px', marginRight: '2px' }} /> ₦2,500</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card_footer">
                                        <img src={cardFootericon} alt="" style={{ width: '30px' }}/>
                                        <p>1 / 2 Signed</p>
                                    </div>
                                </div>
                            </div>
                        
                            <div className="card_holder" onClick={showModal}>
                                <div className="card">
                                    <div className="card_img_top">
                                        <img src={cardImgTop} alt=""/>
                                        <div className="card_img_overlay">
                                            <div className="top">
                                                <div className="level">
                                                    <p>Lv. 2</p>
                                                </div>
                                                <div className="heart">
                                                    <img src={heartIcon} alt=""/>
                                                </div>
                                            </div>
                                            <div className="bottom">
                                                <Button type="primary">Join Match</Button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card_body">
                                        <h6>Sep 02 - Starting At 06:00 pm</h6>
                                        <div className="card_game_title">
                                            <img src={xboxLogo} alt="" style={{ width: '15px' }}/>
                                            <p>Fifa 20: Standard Edition</p>
                                        </div>
                                        <div className="pge_box">
                                            <div className="prize_pool">
                                                <label>Prize Pool</label>
                                                <p><img src={moneyIcon} alt="" style={{ width: '14px', marginRight: '2px' }} /> ₦5,000</p>
                                            </div>
                                            <div className="game_mode">
                                                <label>Game Mode</label>
                                                <p><img src={vsIcon} alt="" style={{ width: '14px', marginRight: '2px' }} /> 1 v 1</p>
                                            </div>
                                            <div className="entry_fee">
                                                <label>Entry Fee</label>
                                                <p><img src={tagIcon} alt="" style={{ width: '14px', marginRight: '2px' }} /> ₦2,500</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card_footer">
                                        <img src={cardFootericon} alt="" style={{ width: '30px' }}/>
                                        <p>1 / 2 Signed</p>
                                    </div>
                                </div>
                            </div>

                            <div className="card_holder" onClick={showModal}>
                                <div className="card">
                                    <div className="card_img_top">
                                        <img src={cardImgTop} alt=""/>
                                        <div className="card_img_overlay">
                                            <div className="top">
                                                <div className="level">
                                                    <p>Lv. 2</p>
                                                </div>
                                                <div className="heart">
                                                    <img src={heartIcon} alt=""/>
                                                </div>
                                            </div>
                                            <div className="bottom">
                                                <Button type="primary">Join Match</Button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card_body">
                                        <h6>Sep 02 - Starting At 06:00 pm</h6>
                                        <div className="card_game_title">
                                            <img src={xboxLogo} alt="" style={{ width: '15px' }}/>
                                            <p>Fifa 20: Standard Edition</p>
                                        </div>
                                        <div className="pge_box">
                                            <div className="prize_pool">
                                                <label>Prize Pool</label>
                                                <p><img src={moneyIcon} alt="" style={{ width: '14px', marginRight: '2px' }} /> ₦5,000</p>
                                            </div>
                                            <div className="game_mode">
                                                <label>Game Mode</label>
                                                <p><img src={vsIcon} alt="" style={{ width: '14px', marginRight: '2px' }} /> 1 v 1</p>
                                            </div>
                                            <div className="entry_fee">
                                                <label>Entry Fee</label>
                                                <p><img src={tagIcon} alt="" style={{ width: '14px', marginRight: '2px' }} /> ₦2,500</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card_footer">
                                        <img src={cardFootericon} alt="" style={{ width: '30px' }}/>
                                        <p>1 / 2 Signed</p>
                                    </div>
                                </div>
                            </div>

                            <div className="card_holder" onClick={showModal}>
                                <div className="card">
                                    <div className="card_img_top">
                                        <img src={cardImgTop} alt=""/>
                                        <div className="card_img_overlay">
                                            <div className="top">
                                                <div className="level">
                                                    <p>Lv. 2</p>
                                                </div>
                                                <div className="heart">
                                                    <img src={heartIcon} alt=""/>
                                                </div>
                                            </div>
                                            <div className="bottom">
                                                <Button type="primary">Join Match</Button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card_body">
                                        <h6>Sep 02 - Starting At 06:00 pm</h6>
                                        <div className="card_game_title">
                                            <img src={xboxLogo} alt="" style={{ width: '15px' }}/>
                                            <p>Fifa 20: Standard Edition</p>
                                        </div>
                                        <div className="pge_box">
                                            <div className="prize_pool">
                                                <label>Prize Pool</label>
                                                <p><img src={moneyIcon} alt="" style={{ width: '14px', marginRight: '2px' }} /> ₦5,000</p>
                                            </div>
                                            <div className="game_mode">
                                                <label>Game Mode</label>
                                                <p><img src={vsIcon} alt="" style={{ width: '14px', marginRight: '2px' }} /> 1 v 1</p>
                                            </div>
                                            <div className="entry_fee">
                                                <label>Entry Fee</label>
                                                <p><img src={tagIcon} alt="" style={{ width: '14px', marginRight: '2px' }} /> ₦2,500</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card_footer">
                                        <img src={cardFootericon} alt="" style={{ width: '30px' }}/>
                                        <p>1 / 2 Signed</p>
                                    </div>
                                </div>
                            </div>

                            <div className="card_holder" onClick={showModal}>
                                <div className="card">
                                    <div className="card_img_top">
                                        <img src={cardImgTop} alt=""/>
                                        <div className="card_img_overlay">
                                            <div className="top">
                                                <div className="level">
                                                    <p>Lv. 2</p>
                                                </div>
                                                <div className="heart">
                                                    <img src={heartIcon} alt=""/>
                                                </div>
                                            </div>
                                            <div className="bottom">
                                                <Button type="primary">Join Match</Button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card_body">
                                        <h6>Sep 02 - Starting At 06:00 pm</h6>
                                        <div className="card_game_title">
                                            <img src={xboxLogo} alt="" style={{ width: '15px' }}/>
                                            <p>Fifa 20: Standard Edition</p>
                                        </div>
                                        <div className="pge_box">
                                            <div className="prize_pool">
                                                <label>Prize Pool</label>
                                                <p><img src={moneyIcon} alt="" style={{ width: '14px', marginRight: '2px' }} /> ₦5,000</p>
                                            </div>
                                            <div className="game_mode">
                                                <label>Game Mode</label>
                                                <p><img src={vsIcon} alt="" style={{ width: '14px', marginRight: '2px' }} /> 1 v 1</p>
                                            </div>
                                            <div className="entry_fee">
                                                <label>Entry Fee</label>
                                                <p><img src={tagIcon} alt="" style={{ width: '14px', marginRight: '2px' }} /> ₦2,500</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card_footer">
                                        <img src={cardFootericon} alt="" style={{ width: '30px' }}/>
                                        <p>1 / 2 Signed</p>
                                    </div>
                                </div>
                            </div>
                        
                        </Slider>
                    </div>
                </div>
               
                <hr />

                <div className="my_timeline">
                    <div className="mini_top_bar">
                        <h4>My Timeline</h4>
                    </div>
                    <div className="regular_content">
                        <Slider {...settings}>

                            <div className="card_holder" onClick={showModal}>
                                <div className="card">
                                    <div className="card_img_top">
                                        <img src={cardImgTop} alt=""/>
                                        <div className="card_img_overlay">
                                            <div className="top">
                                                <div className="level">
                                                    <p>Lv. 2</p>
                                                </div>
                                                <div className="heart">
                                                    <img src={heartIcon} alt=""/>
                                                </div>
                                            </div>
                                            <div className="bottom">
                                                <Button type="primary">Join Match</Button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card_body">
                                        <h6>Sep 02 - Starting At 06:00 pm</h6>
                                        <div className="card_game_title">
                                            <img src={xboxLogo} alt="" style={{ width: '15px' }}/>
                                            <p>Fifa 20: Standard Edition</p>
                                        </div>
                                        <div className="pge_box">
                                            <div className="prize_pool">
                                                <label>Prize Pool</label>
                                                <p><img src={moneyIcon} alt="" style={{ width: '14px', marginRight: '2px' }} /> ₦5,000</p>
                                            </div>
                                            <div className="game_mode">
                                                <label>Game Mode</label>
                                                <p><img src={vsIcon} alt="" style={{ width: '14px', marginRight: '2px' }} /> 1 v 1</p>
                                            </div>
                                            <div className="entry_fee">
                                                <label>Entry Fee</label>
                                                <p><img src={tagIcon} alt="" style={{ width: '14px', marginRight: '2px' }} /> ₦2,500</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card_footer">
                                        <img src={cardFootericon} alt="" style={{ width: '30px' }}/>
                                        <p>1 / 2 Signed</p>
                                    </div>
                                </div>
                            </div>

                            <div className="card_holder" onClick={showModal}>
                                <div className="card">
                                    <div className="card_img_top">
                                        <img src={cardImgTop} alt=""/>
                                        <div className="card_img_overlay">
                                            <div className="top">
                                                <div className="level">
                                                    <p>Lv. 2</p>
                                                </div>
                                                <div className="heart">
                                                    <img src={heartIcon} alt=""/>
                                                </div>
                                            </div>
                                            <div className="bottom">
                                                <Button type="primary">Join Match</Button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card_body">
                                        <h6>Sep 02 - Starting At 06:00 pm</h6>
                                        <div className="card_game_title">
                                            <img src={xboxLogo} alt="" style={{ width: '15px' }}/>
                                            <p>Fifa 20: Standard Edition</p>
                                        </div>
                                        <div className="pge_box">
                                            <div className="prize_pool">
                                                <label>Prize Pool</label>
                                                <p><img src={moneyIcon} alt="" style={{ width: '14px', marginRight: '2px' }} /> ₦5,000</p>
                                            </div>
                                            <div className="game_mode">
                                                <label>Game Mode</label>
                                                <p><img src={vsIcon} alt="" style={{ width: '14px', marginRight: '2px' }} /> 1 v 1</p>
                                            </div>
                                            <div className="entry_fee">
                                                <label>Entry Fee</label>
                                                <p><img src={tagIcon} alt="" style={{ width: '14px', marginRight: '2px' }} /> ₦2,500</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card_footer">
                                        <img src={cardFootericon} alt="" style={{ width: '30px' }}/>
                                        <p>1 / 2 Signed</p>
                                    </div>
                                </div>
                            </div>
                        
                            <div className="card_holder" onClick={showModal}>
                                <div className="card">
                                    <div className="card_img_top">
                                        <img src={cardImgTop} alt=""/>
                                        <div className="card_img_overlay">
                                            <div className="top">
                                                <div className="level">
                                                    <p>Lv. 2</p>
                                                </div>
                                                <div className="heart">
                                                    <img src={heartIcon} alt=""/>
                                                </div>
                                            </div>
                                            <div className="bottom">
                                                <Button type="primary">Join Match</Button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card_body">
                                        <h6>Sep 02 - Starting At 06:00 pm</h6>
                                        <div className="card_game_title">
                                            <img src={xboxLogo} alt="" style={{ width: '15px' }}/>
                                            <p>Fifa 20: Standard Edition</p>
                                        </div>
                                        <div className="pge_box">
                                            <div className="prize_pool">
                                                <label>Prize Pool</label>
                                                <p><img src={moneyIcon} alt="" style={{ width: '14px', marginRight: '2px' }} /> ₦5,000</p>
                                            </div>
                                            <div className="game_mode">
                                                <label>Game Mode</label>
                                                <p><img src={vsIcon} alt="" style={{ width: '14px', marginRight: '2px' }} /> 1 v 1</p>
                                            </div>
                                            <div className="entry_fee">
                                                <label>Entry Fee</label>
                                                <p><img src={tagIcon} alt="" style={{ width: '14px', marginRight: '2px' }} /> ₦2,500</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card_footer">
                                        <img src={cardFootericon} alt="" style={{ width: '30px' }}/>
                                        <p>1 / 2 Signed</p>
                                    </div>
                                </div>
                            </div>

                            <div className="card_holder" onClick={showModal}>
                                <div className="card">
                                    <div className="card_img_top">
                                        <img src={cardImgTop} alt=""/>
                                        <div className="card_img_overlay">
                                            <div className="top">
                                                <div className="level">
                                                    <p>Lv. 2</p>
                                                </div>
                                                <div className="heart">
                                                    <img src={heartIcon} alt=""/>
                                                </div>
                                            </div>
                                            <div className="bottom">
                                                <Button type="primary">Join Match</Button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card_body">
                                        <h6>Sep 02 - Starting At 06:00 pm</h6>
                                        <div className="card_game_title">
                                            <img src={xboxLogo} alt="" style={{ width: '15px' }}/>
                                            <p>Fifa 20: Standard Edition</p>
                                        </div>
                                        <div className="pge_box">
                                            <div className="prize_pool">
                                                <label>Prize Pool</label>
                                                <p><img src={moneyIcon} alt="" style={{ width: '14px', marginRight: '2px' }} /> ₦5,000</p>
                                            </div>
                                            <div className="game_mode">
                                                <label>Game Mode</label>
                                                <p><img src={vsIcon} alt="" style={{ width: '14px', marginRight: '2px' }} /> 1 v 1</p>
                                            </div>
                                            <div className="entry_fee">
                                                <label>Entry Fee</label>
                                                <p><img src={tagIcon} alt="" style={{ width: '14px', marginRight: '2px' }} /> ₦2,500</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card_footer">
                                        <img src={cardFootericon} alt="" style={{ width: '30px' }}/>
                                        <p>1 / 2 Signed</p>
                                    </div>
                                </div>
                            </div>

                            <div className="card_holder" onClick={showModal}>
                                <div className="card">
                                    <div className="card_img_top">
                                        <img src={cardImgTop} alt=""/>
                                        <div className="card_img_overlay">
                                            <div className="top">
                                                <div className="level">
                                                    <p>Lv. 2</p>
                                                </div>
                                                <div className="heart">
                                                    <img src={heartIcon} alt=""/>
                                                </div>
                                            </div>
                                            <div className="bottom">
                                                <Button type="primary">Join Match</Button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card_body">
                                        <h6>Sep 02 - Starting At 06:00 pm</h6>
                                        <div className="card_game_title">
                                            <img src={xboxLogo} alt="" style={{ width: '15px' }}/>
                                            <p>Fifa 20: Standard Edition</p>
                                        </div>
                                        <div className="pge_box">
                                            <div className="prize_pool">
                                                <label>Prize Pool</label>
                                                <p><img src={moneyIcon} alt="" style={{ width: '14px', marginRight: '2px' }} /> ₦5,000</p>
                                            </div>
                                            <div className="game_mode">
                                                <label>Game Mode</label>
                                                <p><img src={vsIcon} alt="" style={{ width: '14px', marginRight: '2px' }} /> 1 v 1</p>
                                            </div>
                                            <div className="entry_fee">
                                                <label>Entry Fee</label>
                                                <p><img src={tagIcon} alt="" style={{ width: '14px', marginRight: '2px' }} /> ₦2,500</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card_footer">
                                        <img src={cardFootericon} alt="" style={{ width: '30px' }}/>
                                        <p>1 / 2 Signed</p>
                                    </div>
                                </div>
                            </div>

                            <div className="card_holder" onClick={showModal}>
                                <div className="card">
                                    <div className="card_img_top">
                                        <img src={cardImgTop} alt=""/>
                                        <div className="card_img_overlay">
                                            <div className="top">
                                                <div className="level">
                                                    <p>Lv. 2</p>
                                                </div>
                                                <div className="heart">
                                                    <img src={heartIcon} alt=""/>
                                                </div>
                                            </div>
                                            <div className="bottom">
                                                <Button type="primary">Join Match</Button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card_body">
                                        <h6>Sep 02 - Starting At 06:00 pm</h6>
                                        <div className="card_game_title">
                                            <img src={xboxLogo} alt="" style={{ width: '15px' }}/>
                                            <p>Fifa 20: Standard Edition</p>
                                        </div>
                                        <div className="pge_box">
                                            <div className="prize_pool">
                                                <label>Prize Pool</label>
                                                <p><img src={moneyIcon} alt="" style={{ width: '14px', marginRight: '2px' }} /> ₦5,000</p>
                                            </div>
                                            <div className="game_mode">
                                                <label>Game Mode</label>
                                                <p><img src={vsIcon} alt="" style={{ width: '14px', marginRight: '2px' }} /> 1 v 1</p>
                                            </div>
                                            <div className="entry_fee">
                                                <label>Entry Fee</label>
                                                <p><img src={tagIcon} alt="" style={{ width: '14px', marginRight: '2px' }} /> ₦2,500</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card_footer">
                                        <img src={cardFootericon} alt="" style={{ width: '30px' }}/>
                                        <p>1 / 2 Signed</p>
                                    </div>
                                </div>
                            </div>
                        
                        </Slider>
                    </div>
                </div> 
            
            </div>
        </div>
    );
}

export default HomeContent;